import { useState } from 'react';

import { ModalContentType, ModalContext } from './ModalContext';

export function ModalProvider({ children }: { children: React.ReactNode }) {
  const [isModalOpened, setIsModalOpened] = useState(false);
  const [contentType, setContentType] = useState<ModalContentType>('consult');

  const openModal = (type: ModalContentType) => {
    setContentType(type);
    setIsModalOpened(true);
  };
  const closeModal = () => setIsModalOpened(false);

  return (
    <ModalContext.Provider value={{ isModalOpened, openModal, closeModal, contentType }}>
      {children}
    </ModalContext.Provider>
  );
}
